import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { NumericOnlyDirective } from './number-input.directive';
import { IconModule } from '../icon/icon.module';
import { ErrorMessageModule } from '../error-message/error-message.module';

@NgModule({
  declarations: [InputComponent, NumericOnlyDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    IconModule,
    ErrorMessageModule,
  ],
  exports: [InputComponent, NumericOnlyDirective],
})
export class InputModule {}
